import { withRouter } from 'react-router-dom';

import requireGuestAuthentication from '../../_hoc/requireGuestAuthentication.jsx';
import AppRoute from './AppRoute.jsx';

export default withRouter(requireGuestAuthentication()(AppRoute));
